import React from 'react'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'; 

export default function ReadyToWork() {
    
    // Parent container: We remove 'opacity' so the background is always there
    // We only use this to trigger the stagger effect for children
    const containerVariants = {
        hidden: {}, 
        visible: { 
            transition: { 
                staggerChildren: 0.2 
            } 
        }
    };

    // Text & Button Child Animation: Professional "Fade & Focus" entrance
    const itemVariants = {
        hidden: { 
            opacity: 0, 
            y: 15,
            filter: "blur(4px)" // Added a slight blur for a high-end feel
        },
        visible: { 
            opacity: 1, 
            y: 0, 
            filter: "blur(0px)",
            transition: { 
                duration: 0.7, 
                ease: [0.215, 0.61, 0.355, 1] 
            } 
        }
    };

    return (
        <>
        {/* The background stays untouched by animation here */}
        <div className="ready-to-con">
            <motion.div 
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
            >
                  <motion.div variants={itemVariants} className='ready-to-title'>
                    Ready to Work, Let's Chat
                  </motion.div>
                  
                  <motion.div variants={itemVariants} className='ready-to-description'>
                    Our team of experts is ready to collaborate with
                  </motion.div>
                  
                  <motion.div variants={itemVariants} className='ready-to-description'>
                    you every step of the way, from initial consultation to implementation.
                  </motion.div>

                  <motion.div 
                    variants={itemVariants}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    className="d-inline-block"
                  >
                    <Link to='/contact-us'>
                        <div className='ready-to-button'>Contact Us Today!</div>
                    </Link>
                  </motion.div>
            </motion.div>
        </div>
        </>
    )
};